/*import {
    repo_menu_icon_link,
} from '../../Utils'*/

//import { getTokenInfo } from './../../UseToken';

export default function SidebarData(props) {
    let pathver = false
    try {
        if (props.rotas !== undefined)
            pathver = false
    } catch {
        pathver = true
    }
    
    return [
        {
            id: '10',
            title: 'Painel Principal',
            title_lang: 'painel_principal',
            path: pathver ? ' ' : props.rotas.Main.view.endpoint,
            icon: 'house',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '15',
            title: 'Calendário',
            title_lang: 'calendar',
            path: pathver ? '' : props.rotas.Calendar_Event.view.endpoint,
            path_base: pathver ? '' : props.rotas.Calendar_Event.base,
            icon: 'calendar3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: []
        },
        {
            id: '80',
            title: 'Concurso',
            title_lang: 'contest',
            path: pathver ? '' : props.rotas.Content_Contest.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Contest.base,
            icon: 'archive',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'formation',
            show_submenu: false,
            submenu: [
                {
                    id: '81',
                    title: 'Lista de Inscritos',
                    title_lang: 'contest_list',
                    path: pathver ? '' : props.rotas.Content_Contest.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Contest.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '82',
                    title: 'Novo Inscrito',
                    title_lang: 'contest_new',
                    path: pathver ? '' : props.rotas.Content_Contest.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Contest.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '83',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Contest.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Contest.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '90',
            title: 'Lista de cursos',
            title_lang: 'courses_list',
            path: pathver ? '' : props.rotas.Formation_Courses.list.endpoint,
            path_base: pathver ? '' : props.rotas.Formation_Courses.base,
            icon: 'book',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: true,
            submenu: [
                {
                    id: '91',
                    title: 'Lista de cursos a decorrer/a iniciar ',
                    title_lang: 'courses_in_progress',
                    path: pathver ? '' : props.rotas.Formation_Courses.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Courses.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '941',
                    title: 'Lista de cursos terminados',
                    title_lang: 'courses_ended',
                    path: pathver ? '' : props.rotas.Formation_Courses.list2.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Courses.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '92',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Formation_Courses.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Courses.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '93',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Formation_Courses.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Courses.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '940',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Formation_Courses.gest.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Courses.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '98',
            title: 'Cursos',
            title_lang: 'courses',
            path: pathver ? '' : props.rotas.Formation_Module.list.endpoint,
            path_base: pathver ? '' : props.rotas.Formation_Module.base,
            icon: 'book-half',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '99',
                    title: 'Lista de Modulos',
                    title_lang: 'module_list',
                    path: pathver ? '' : props.rotas.Formation_Module.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Module.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '100',
                    title: 'Novo modulo',
                    title_lang: 'module_new',
                    path: pathver ? '' : props.rotas.Formation_Module.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Module.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '101',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Formation_Module.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Module.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '102',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Formation_Module.gest.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Module.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },


        {
            id: '5001',
            title: 'Entidade',
            title_lang: 'energy_entity',
            path: pathver ? '' : props.rotas.MonitoringEntity.list.endpoint,
            path_base: pathver ? '' : props.rotas.MonitoringEntity.base,
            icon: 'person',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '5002',
                    title: 'Lista de entidades',
                    title_lang: 'energy_entities_list',
                    path: pathver ? '' : props.rotas.MonitoringEntity.list.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringEntity.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5003',
                    title: 'Nova entidade',
                    title_lang: 'energy_entity_new',
                    path: pathver ? '' : props.rotas.MonitoringEntity.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringEntity.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5004',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.MonitoringEntity.view.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringEntity.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '5011',
            title: 'Operação',
            title_lang: 'operation',
            path: pathver ? '' : props.rotas.MonitoringOperation.list.endpoint,
            path_base: pathver ? '' : props.rotas.MonitoringOperation.base,
            icon: 'gear',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '5012',
                    title: 'Lista de operações',
                    title_lang: 'operations_list',
                    path: pathver ? '' : props.rotas.MonitoringOperation.list.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringOperation.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5013',
                    title: 'Nova operação',
                    title_lang: 'operation_new',
                    path: pathver ? '' : props.rotas.MonitoringOperation.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringOperation.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5014',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.MonitoringOperation.view.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringOperation.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '5021',
            title: 'Consumos',
            title_lang: 'consumo',
            path: pathver ? '' : props.rotas.MonitoringConsumos.list.endpoint,
            path_base: pathver ? '' : props.rotas.MonitoringConsumos.base,
            icon: 'gear',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '5022',
                    title: 'Lista de consumos',
                    title_lang: 'consumos_list',
                    path: pathver ? '' : props.rotas.MonitoringConsumos.list.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringConsumos.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5023',
                    title: 'Nova consumo',
                    title_lang: 'consumo_new',
                    path: pathver ? '' : props.rotas.MonitoringConsumos.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringConsumos.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5024',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.MonitoringConsumos.view.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringConsumos.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '5031',
            title: 'AutoConsumo',
            title_lang: 'autoconsumo',
            path: pathver ? '' : props.rotas.MonitoringAutoConsumo.list.endpoint,
            path_base: pathver ? '' : props.rotas.MonitoringAutoConsumo.base,
            icon: 'gear',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '5032',
                    title: 'Lista de autoconsumos',
                    title_lang: 'autoconsumos_list',
                    path: pathver ? '' : props.rotas.MonitoringAutoConsumo.list.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringAutoConsumo.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5033',
                    title: 'Nova autoconsumo',
                    title_lang: 'autoconsumo_new',
                    path: pathver ? '' : props.rotas.MonitoringAutoConsumo.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringAutoConsumo.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5034',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.MonitoringAutoConsumo.view.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringAutoConsumo.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '5041',
            title: 'Plano de Acção',
            title_lang: 'plano_accao',
            path: pathver ? '' : props.rotas.MonitoringPlanoAccao.list.endpoint,
            path_base: pathver ? '' : props.rotas.MonitoringPlanoAccao.base,
            icon: 'gear',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '5042',
                    title: 'Lista de autoconsumos',
                    title_lang: 'plano_accao_list',
                    path: pathver ? '' : props.rotas.MonitoringPlanoAccao.list.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringPlanoAccao.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5043',
                    title: 'Nova autoconsumo',
                    title_lang: 'plano_accao_new',
                    path: pathver ? '' : props.rotas.MonitoringPlanoAccao.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringPlanoAccao.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5044',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.MonitoringPlanoAccao.view.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringPlanoAccao.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '5051',
            title: 'Resultados',
            title_lang: 'resultado',
            path: pathver ? '' : props.rotas.MonitoringResultados.list.endpoint,
            path_base: pathver ? '' : props.rotas.MonitoringResultados.base,
            icon: 'gear',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '5052',
                    title: 'Lista de autoconsumos',
                    title_lang: 'resultados_list',
                    path: pathver ? '' : props.rotas.MonitoringResultados.list.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringResultados.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5053',
                    title: 'Nova autoconsumo',
                    title_lang: 'resultado_new',
                    path: pathver ? '' : props.rotas.MonitoringResultados.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringResultados.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '5054',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.MonitoringResultados.view.endpoint,
                    path_base: pathver ? '' : props.rotas.MonitoringResultados.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },


        {
            id: '4001',
            title: 'Notas',
            title_lang: 'notes',
            path: pathver ? '' : props.rotas.Note.list.endpoint,
            path_base: pathver ? '' : props.rotas.Note.base,
            icon: 'stickies',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '4011',
                    title: 'Lista de Notas',
                    title_lang: 'notes_list',
                    path: pathver ? '' : props.rotas.Note.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Note.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '4021',
                    title: 'Nova nota',
                    title_lang: 'note_new',
                    path: pathver ? '' : props.rotas.Note.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Note.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '4031',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Note.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Note.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '4002',
            title: 'Mensagens',
            title_lang: 'messages',
            path: pathver ? '' : props.rotas.Message.list.endpoint,
            path_base: pathver ? '' : props.rotas.Message.base,
            icon: 'chat-quote',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '4012',
                    title: 'Lista de Mensagens',
                    title_lang: 'messages_list',
                    path: pathver ? '' : props.rotas.Message.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Message.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '4022',
                    title: 'Nova nota',
                    title_lang: 'message_new',
                    path: pathver ? '' : props.rotas.Message.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Message.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '4032',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Message.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Message.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '94',
            title: 'Categorias',
            title_lang: 'categories',
            path: pathver ? '' : props.rotas.Formation_Category.list.endpoint,
            path_base: pathver ? '' : props.rotas.Formation_Category.base,
            icon: 'tags',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'formation',
            show_submenu: false,
            submenu: [
                {
                    id: '95',
                    title: 'Lista de Categorias',
                    title_lang: 'category_list',
                    path: pathver ? '' : props.rotas.Formation_Category.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '96',
                    title: 'Nova formação',
                    title_lang: 'category_new',
                    path: pathver ? '' : props.rotas.Formation_Category.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '97',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Formation_Category.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Formation_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '20',
            title: 'Conteúdo',
            title_lang: 'content',
            path: pathver ? '' : props.rotas.Content.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content.base,
            icon: 'diagram-3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '21',
                    title: 'Lista de Conteúdos',
                    title_lang: 'content_list',
                    path: pathver ? '' : props.rotas.Content.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '22',
                    title: 'Novo Conteúdo',
                    title_lang: 'content_new',
                    path: pathver ? '' : props.rotas.Content.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '23',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '40',
            title: 'Notícias',
            title_lang: 'articles',
            path: pathver ? '' : props.rotas.Content_News.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_News.base,
            icon: 'newspaper',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '41',
                    title: 'Lista de Notícias',
                    title_lang: 'articles_list',
                    path: pathver ? '' : props.rotas.Content_News.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_News.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '42',
                    title: 'Nova Notícia',
                    title_lang: 'article_new',
                    path: pathver ? '' : props.rotas.Content_News.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_News.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '43',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_News.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_News.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '50',
            title: 'Banners',
            title_lang: 'banners',
            path: pathver ? '' : props.rotas.Content_Banner.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Banner.base,
            icon: 'images',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '51',
                    title: 'Lista de Banners',
                    title_lang: 'banners_list',
                    path: pathver ? '' : props.rotas.Content_Banner.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Banner.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '52',
                    title: 'Novo Banner',
                    title_lang: 'banner_new',
                    path: pathver ? '' : props.rotas.Content_Banner.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Banner.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '53',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Banner.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Banner.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '60',
            title: 'Galeria',
            title_lang: 'galleries',
            path: pathver ? '' : props.rotas.Content_Gallery.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Gallery.base,
            icon: 'images',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '61',
                    title: 'Lista de Galerias',
                    title_lang: 'galleries_list',
                    path: pathver ? '' : props.rotas.Content_Gallery.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Gallery.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '62',
                    title: 'Nova Galeria',
                    title_lang: 'gallery_new',
                    path: pathver ? '' : props.rotas.Content_Gallery.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Gallery.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '63',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Gallery.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Gallery.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '70',
            title: 'Testemunhos',
            title_lang: 'testemonies',
            path: pathver ? '' : props.rotas.Content_Testemony.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Testemony.base,
            icon: 'chat-quote',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '71',
                    title: 'Lista de Testemunhos',
                    title_lang: 'testemonies_list',
                    path: pathver ? '' : props.rotas.Content_Testemony.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Testemony.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '72',
                    title: 'Novo Testemunho',
                    title_lang: 'testemony_new',
                    path: pathver ? '' : props.rotas.Content_Testemony.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Testemony.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '73',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Testemony.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Testemony.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '999',
            title: '',
            path: pathver ? ' ' : '/',
            icon: '',
            cName: 'list-divider',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },   
        {
            id: '1010',
            title: 'Perfis',
            title_lang: 'perfis',
            path: pathver ? ' ' : props.rotas.Perfil.list.endpoint,
            icon: 'person-badge',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            show_submenu: false,
            submenu: [
                {
                    id: '1011',
                    title: 'Lista de Perfis',
                    title_lang: 'lista_perfis',
                    path: pathver ? ' ' : props.rotas.Perfil.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1012',
                    title: 'Novo Perfil',
                    title_lang: 'novo',
                    path: pathver ? ' ' : props.rotas.Perfil.regist.endpoint,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1013',
                    title: '',
                    path: pathver ? ' ' : props.rotas.Perfil.view.endpoint,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },

            ]
        },
        {
            id: "1060",
            edit: true,
            icon: "people",
            //path: "/entrepreneur_list",
            //path_base: "/entrepreneur",
            path: pathver ? '' : props.rotas.Formador.list.endpoint,
            path_base: pathver ? '' : props.rotas.Formador.base,
            view: true,
            allow: true,
            cName: "",
            title: "Formador",
            create: true,
            remove: true,
            title_lang: "trainer",
            show_submenu: false,
            submenu: [
              {
                id: "1061",
                edit: true,
                icon: "",
                //path: "/entrepreneur_list",
                //path_base: "/entrepreneur",
                path: pathver ? '' : props.rotas.Formador.list.endpoint,
                path_base: pathver ? '' : props.rotas.Formador.base,
                view: true,
                allow: true,
                cName: "",
                title: "Lista de Formadores",
                create: true,
                remove: true,
                submenu: [],
                title_lang: "trainer_list"
              },
              {
                id: "1062",
                edit: true,
                icon: "",
                //path: "/entrepreneur_regist",
                path: pathver ? '' : props.rotas.Formador.regist.endpoint,
                path_base: pathver ? '' : props.rotas.Formador.base,
                view: true,
                allow: true,
                cName: "",
                title: "Inserir Formador",
                create: true,
                remove: true,
                submenu: [],
                //path_base: "/entrepreneur",
                title_lang: "trainer_new"
              },
              {
                id: "1063",
                edit: true,
                icon: "",
                //path: "/entrepreneur_view",
                path: pathver ? '' : props.rotas.Formador.view.endpoint,
                path_base: pathver ? '' : props.rotas.Formador.base,
                view: true,
                allow: true,
                cName: "",
                title: "",
                create: true,
                remove: true,
                submenu: [],
                //path_base: "/entrepreneur",
                title_lang: ""
              }
            ],
        },
        {
            id: "1070",
            edit: true,
            icon: "people",
            //path: "/entrepreneur_list",
            //path_base: "/entrepreneur",
            path: pathver ? '' : props.rotas.Formando.list.endpoint,
            path_base: pathver ? '' : props.rotas.Formando.base,
            view: true,
            allow: true,
            cName: "",
            title: "Formando",
            create: true,
            remove: true,
            title_lang: "trainee",
            show_submenu: false,
            submenu: [
            {
                id: "1071",
                edit: true,
                icon: "",
                //path: "/entrepreneur_list",
                //path_base: "/entrepreneur",
                path: pathver ? '' : props.rotas.Formando.list.endpoint,
                path_base: pathver ? '' : props.rotas.Formando.base,
                view: true,
                allow: true,
                cName: "",
                title: "Lista de Formandos",
                create: true,
                remove: true,
                submenu: [],
                title_lang: "entrepreneur_list"
            },
            {
                id: "1072",
                edit: true,
                icon: "",
                //path: "/entrepreneur_regist",
                path: pathver ? '' : props.rotas.Formando.regist.endpoint,
                path_base: pathver ? '' : props.rotas.Formando.base,
                view: true,
                allow: true,
                cName: "",
                title: "Inserir Formando",
                create: true,
                remove: true,
                submenu: [],
                //path_base: "/entrepreneur",
                title_lang: "entrepreneur_new"
            },
            {
                id: "1073",
                edit: true,
                icon: "",
                //path: "/entrepreneur_view",
                path: pathver ? '' : props.rotas.Formando.view.endpoint,
                path_base: pathver ? '' : props.rotas.Formando.base,
                view: true,
                allow: true,
                cName: "",
                title: "",
                create: true,
                remove: true,
                submenu: [],
                //path_base: "/entrepreneur",
                title_lang: ""
              }
            ],
        },
        {
            id: '1020',
            title: 'Utilizador',
            title_lang: 'webuser',
            path: pathver ? '' : props.rotas.Utilizador.list.endpoint,
            path_base: pathver ? '' : props.rotas.Utilizador.base,
            icon: 'people',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1021',
                    title: 'Lista de Utilizadores',
                    title_lang: 'webuser_list',
                    path: pathver ? '' : props.rotas.Utilizador.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Utilizador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1022',
                    title: 'Inserir Utilizador',
                    title_lang: 'webuser_new',
                    path: pathver ? '' : props.rotas.Utilizador.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Utilizador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1023',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Utilizador.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Utilizador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '1040',
            title: 'Calendário',
            title_lang: 'calendar',
            path: pathver ? '' : props.rotas.Calendar_Category.list.endpoint,
            path_base: pathver ? '' : props.rotas.Calendar_Category.base,
            icon: 'calendar3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1041',
                    title: 'Lista de Categorias',
                    title_lang: 'categories_list',
                    path: pathver ? '' : props.rotas.Calendar_Category.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Calendar_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1042',
                    title: 'Inserir Categoria',
                    title_lang: 'category_new',
                    path: pathver ? '' : props.rotas.Calendar_Category.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Calendar_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1043',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Calendar_Category.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Calendar_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '1080',
            title: 'Cursos disponíveis',
            title_lang: 'courses_available',
            path: pathver ? '' : props.rotas.Courses.list.endpoint,
            path_base: pathver ? '' : props.rotas.Courses.base,
            icon: 'calendar3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1081',
                    title: 'Lista de Cursos',
                    title_lang: 'courses_list',
                    path: pathver ? '' : props.rotas.Courses.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Courses.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1082',
                    title: 'Inserir Curso',
                    title_lang: 'course_new',
                    path: pathver ? '' : props.rotas.Courses.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Courses.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1083',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Courses.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Courses.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '1030',
            title: 'Menus',
            title_lang: 'menus',
            path: pathver ? '' : props.rotas.Structure.list.endpoint,
            path_base: pathver ? '' : props.rotas.Structure.base,
            icon: 'diagram-3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1031',
                    title: 'Lista de Menus',
                    title_lang: 'menus_list',
                    path: pathver ? '' : props.rotas.Structure.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Structure.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1032',
                    title: 'Inserir Menu',
                    title_lang: 'menu_new',
                    path: pathver ? '' : props.rotas.Structure.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Structure.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1033',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Structure.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Structure.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '1050',
            title: 'Categorias',
            title_lang: 'categories',
            path: pathver ? '' : props.rotas.Content_Category.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Category.base,
            icon: 'tags',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1051',
                    title: 'Lista de Categorias',
                    title_lang: 'categories_list',
                    path: pathver ? '' : props.rotas.Content_Category.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1052',
                    title: 'Inserir Categoria',
                    title_lang: 'category_new',
                    path: pathver ? '' : props.rotas.Content_Category.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1053',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Category.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        

      
    ]

}